<template>
  <div class="amendLoginMain">
    <breadcrumb>
      <el-breadcrumb slot="breadcrumb" separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path:'/personal/users/home' }">个人中心</el-breadcrumb-item>
        <el-breadcrumb-item>修改登录密码</el-breadcrumb-item>
      </el-breadcrumb>
    </breadcrumb>
    <div class="setLoginBox" v-if="loginType === 'password'">
      <el-form
        :model="ruleForm2"
        v-show="revisionBox"
        :rules="rules2"
        ref="ruleForm2"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="旧的登录密码：" prop="oldPass">
          <el-input type="password" v-model="ruleForm2.oldPass" placeholder="请您输入旧的登录密码"></el-input>
        </el-form-item>
        <el-form-item label="新的登录密码：" prop="pass">
          <el-input
            type="password"
            v-model="ruleForm2.pass"
            autocomplete="off"
            placeholder="请使用字母和数字组成的6-18位密码"
          ></el-input>
        </el-form-item>
        <el-form-item label="确认新的登录密码：" prop="checkPass">
          <el-input
            type="password"
            v-model="ruleForm2.checkPass"
            autocomplete="off"
            placeholder="请您再次输入新的登录密码"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :disabled="isSubmitIng" @click="submitForm('ruleForm2')">提交</el-button>
        </el-form-item>
      </el-form>
      <div class="setSuccessd textAign ft16" v-show="successBox">
        <img src="../../../../../assets/images/safety/succeed_icon.png">
        <br>修改成功
      </div>
      <div class="setSuccessd textAign ft16" v-show="defeatedBox">
        <img src="../../../../../assets/images/register/fail_icon.png">
        <br>修改失败
      </div>
    </div>
    <set-pwd-by-mobile v-else class="setPwdByMBox"></set-pwd-by-mobile>
  </div>
</template>
<script>
import BaseApi from "@lib/baseApi.js";
import md5 from "@lib/encryption.js";
import breadcrumb from "@common/Breadcrumb.vue";
import setPwdByMobile from "./setPwdByMobile.vue";
import {mapMutations} from "vuex";
export default {
  data() {
    var validatePass3 = (rule, value, callback) => {
      if (value == "") {
        return callback(new Error("旧密码不能为空"));
      }
      callback();
    };
    var pwdReg = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{6,18}$/;
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入新的登录密码"));
      }
      if (!pwdReg.test(value)) {
        callback(new Error("密码不符合规范,请输入字母和数字组成的6-18位密码"));
      }
      if (this.ruleForm2.checkPass !== "") {
        this.$refs.ruleForm2.validateField("checkPass");
      }
      callback();
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入新的登录密码"));
      } else if (value !== this.ruleForm2.pass) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      ruleForm2: {
        pass: "",
        checkPass: "",
        oldPass: ""
      },
      loginType: localStorage.loginType,
      isSubmitIng: false,
      rules2: {
        pass: [{ validator: validatePass, trigger: "blur" }],
        checkPass: [{ validator: validatePass2, trigger: "blur" }],
        oldPass: [{ validator: validatePass3, trigger: "blur" }]
      },
      revisionBox: true,
      successBox: false,
      defeatedBox: false
    };
  },
  methods: {
    ...mapMutations(['setUpdateUserState']),
    submitForm(formName) {
      this.isSubmitIng = true;
      this.$refs[formName].validate(valid => {
        if (valid) {
          var queryStr = {
            handleType: "1",
            newPwd: md5.md5(this.ruleForm2.checkPass),
            oldPwd: md5.md5(this.ruleForm2.oldPass)
          };
          BaseApi.createRpcToken("/user/updatePwd", queryStr, "post")
            .then(
              data => {
                this.revisionBox = false;
                this.successBox = true;
                this.setUpdateUserState("updateLoginPwd")
                setTimeout(() => {
                  this.$router.push({
                    path: "/personal/users/home"
                  });
                  this.isSubmitIng = false;
                }, 2000);
              },
              data => {
                this.isSubmitIng = false;
              }
            )
            .catch(function(e) {
              errorLog(e);
            });
        } else {
          this.isSubmitIng = false;
          console.log("error submit!!");
          return false;
        }
      });
    }
  },
  components: {
    breadcrumb,
    setPwdByMobile
  }
};
</script>
<style lang="scss">
.amendLoginMain {
  padding: 20px;
  box-sizing: border-box;
  .setLoginBox {
    position: relative;
    width: 100%;
    height: 100%;
    .el-form {
      position: absolute;
      display: table;
      width: 440px;
      height: 228px;
      left: 50%;
      top: 50%;
      margin-top: -114px;
      margin-left: -214px;
      .el-input__inner {
        width: 300px;
        height: 30px;
        .el-form-item__label {
          width: 126px;
          font-size: 14px;
          color: #969696;
        }
      }
      .el-form-item__content {
        float: left;
        margin: 0 !important;
        .el-button--primary {
          width: 160px;
          height: 36px;
          margin-left: 141px;
          background: #D81212;
          border: none;
        }
        .el-button--primary:hover {
          background: #a5303d;
        }
      }
      .el-form-item__label {
        width: 140px !important;
        float: left;
        margin: 0;
        font-family: "PingFangSC-Medium";
        font-size: 14px;
        color: #969696;
        text-align: right;
        padding-right: 0;
      }
    }
    .setSuccessd {
      width: 100%;
      position: absolute;
      height: 100px;
      top: 50%;
      margin-top: -50px;
      text-align: center;
      color: #505050;
      font-family: "PingFangSC-Medium";
      img {
        margin-bottom: 10px;
      }
    }
  }
  .setPwdByMBox {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    .el-button--primary {
      width: 160px;
      height: 28px;
      line-height: 7px;
      margin-left: 99px;
      background: #D81212;
      border: none;
    }
    .el-button--primary:hover {
      background: #a5303d;
    }
  }
}
</style>


